/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Attr_Auction_KindInputs */

const cs_sreality_attr_auction_kind = /** @type {(inputs: Sreality_Attr_Auction_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Druh dražby`)
};

const en_sreality_attr_auction_kind = /** @type {(inputs: Sreality_Attr_Auction_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auction kind`)
};

/**
* | output |
* | --- |
* | "Auction kind" |
*
* @param {Sreality_Attr_Auction_KindInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_attr_auction_kind = /** @type {((inputs?: Sreality_Attr_Auction_KindInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Attr_Auction_KindInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_attr_auction_kind(inputs)
	return cs_sreality_attr_auction_kind(inputs)
});